import React from 'react';
import * as styles from './agency-branding-header.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AgencyBrandingHeader = _ref => {
  var _ref$agency = _ref.agency,
    name = _ref$agency.name,
    tinyLogo = _ref$agency.images.tinyLogo,
    logoBackgroundColour = _ref$agency.logoBackgroundColour,
    profileUrl = _ref$agency.profileUrl;
  return ___EmotionJSX(React.Fragment, null, profileUrl && ___EmotionJSX("a", {
    css: styles.banner(logoBackgroundColour),
    href: profileUrl
  }, ___EmotionJSX("img", {
    css: styles.bannerLogo,
    src: tinyLogo,
    alt: "Logo of ".concat(name)
  })), !profileUrl && ___EmotionJSX("div", {
    css: styles.banner(logoBackgroundColour)
  }, ___EmotionJSX("img", {
    css: styles.bannerLogo,
    src: tinyLogo,
    alt: "Logo of ".concat(name)
  })));
};